export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00820.ba68295d.png";